"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _useGuidedSellingStatus = require("../hooks/app/useGuidedSellingStatus");
var _useModalSize2 = require("../hooks/app/useModalSize");
var _PageTemplate = _interopRequireDefault(require("./PageTemplate"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Modal component expects a react component child so this is
 * just a workaround to accommodate that requirement
 */
var ModalContent = function ModalContent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gs-app"
  }, children);
};
var GuidedSellingModal = function GuidedSellingModal() {
  var _useGuidedSellingStat = (0, _useGuidedSellingStatus.useGuidedSellingStatus)(),
    isGuidedSellingModalOpen = _useGuidedSellingStat.isGuidedSellingModalOpen;
  var _useModalSize = (0, _useModalSize2.useModalSize)(),
    currentModalSize = _useModalSize.currentModalSize;
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.OverlayProvider, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Modal, {
    isOpen: isGuidedSellingModalOpen,
    isClosable: false,
    size: currentModalSize,
    animate: true,
    srName: "app-modal"
  }, /*#__PURE__*/_react.default.createElement(ModalContent, null, /*#__PURE__*/_react.default.createElement(_PageTemplate.default, null))));
};
var _default = GuidedSellingModal;
exports.default = _default;